import { AnyAction } from 'redux';
import { put, select } from 'redux-saga/effects';
import Notifications from 'react-notification-system-redux';

import * as actions from '@/store/actions';
import { apiClient, throwSubmissionError } from '@/utils';
import { AxiosResponse } from 'axios';
import qs from 'qs';
import { push } from 'connected-react-router';
import { ApplicationState } from '@/store';
import { getAllItems } from '@/utils/common';
import exportToXLSX from '@/utils/exportToXLSX';
import { Payment } from '@/types';
import { getTranslate } from 'react-localize-redux';
import { RootState } from 'MyTypes';

// Payments settings
export function* fetchPaymentSettings(action: AnyAction) {
    try {
        const response: AxiosResponse = yield apiClient.get('/payment/settings', {
            params: { IncludeAdminPaymentOptions: true, IncludePaymentProviderOptions: true },
        });

        yield put(actions.FETCH_PAYMENT_SETTINGS.success(response.data));
    } catch (error) {
        yield put(actions.FETCH_PAYMENT_SETTINGS.failure(error));
    }
}

export function* editPaymentSettings({ payload }: AnyAction) {
    try {
        const location: Location = yield select((s: ApplicationState) => s.router.location);
        const response: AxiosResponse = yield apiClient.put('/payment/settings', payload);

        yield put(actions.EDIT_PAYMENT_SETTINGS.success(response));

        const query = qs.parse(location.search.slice(1));

        if (query.afterSuccess) {
            yield put(push(query.afterSuccess as string))
        }
    } catch (error) {
        yield put(actions.EDIT_PAYMENT_SETTINGS.failure(throwSubmissionError(error)));
    }
}

// Billmate API settings
export function* fetchBillmateAPISettings(action: AnyAction) {
    try {
        const response: AxiosResponse = yield apiClient.get('/payment/billmate/apisettings');

        yield put(actions.FETCH_BILLMATE_API_SETTINGS.success(response.data));
    } catch (error) {
        yield put(actions.FETCH_BILLMATE_API_SETTINGS.failure(error));
    }
}

export function* createBillmateAPISettings({ payload }: AnyAction) {
    try {
        const response: AxiosResponse = yield apiClient.post('/payment/billmate/apisettings', payload);

        yield put(actions.CREATE_BILLMATE_API_SETTINGS.success(response));
    } catch (error) {
        yield put(actions.CREATE_BILLMATE_API_SETTINGS.failure(throwSubmissionError(error)));
    }
}

export function* editBillmateAPISettings({ payload }: AnyAction) {
    try {
        const response: AxiosResponse = yield apiClient.put('/payment/billmate/apisettings', payload);

        yield put(actions.EDIT_BILLMATE_API_SETTINGS.success(response));
    } catch (error) {
        yield put(actions.EDIT_BILLMATE_API_SETTINGS.failure(throwSubmissionError(error)));
    }
}

export function* testBillmateAPISettings({ payload }: AnyAction) {
    try {
        const response: AxiosResponse = yield apiClient.post('/payment/billmate/apisettings/test', payload);

        yield put(actions.FETCH_TEST_BILLMATE_API_SETTINGS.success(response.data));
    } catch (error) {
        yield put(actions.FETCH_TEST_BILLMATE_API_SETTINGS.failure(error));
    }
}

export function* fetchPayments({payload, meta = {}}: AnyAction) {
    try {
        const localizeState: RootState['localize'] = yield select((state) => state.localize);
        const translate = getTranslate(localizeState);

        const response: AxiosResponse = yield apiClient.get('/articles/payments', {
            params: payload,
        });

        if (meta.toXLSX && meta.columns) {
            const payments: { total: number, data: Payment[] } = yield select((s: any) => s.payments);
            if (payments.total > 300) {
                yield put(Notifications.show({ title: translate('bookings.pleaseWait') as string }, 'info'));
            }
            yield put({ type: actions.EXPORT_PAYMENTS.REQUEST });
            const allResults: Payment[] = yield getAllItems(response);
            exportToXLSX(response.data && allResults, meta.columns);
            yield put({ type: actions.EXPORT_PAYMENTS.SUCCESS });
        }

        yield put(actions.FETCH_PAYMENTS.success(response.data));
    } catch (error) {
        if (meta.toXLSX) {
            yield put({ type: actions.EXPORT_PAYMENTS.FAILURE, payload: error });
        }
        yield put(actions.FETCH_PAYMENTS.failure(error));
    }
}

